
// vue
import { defineComponent, ref, toRefs, watch } from 'vue';

type Decoding = 'auto' | 'async' | 'sync' | undefined;

export default defineComponent({
  name: 'RetinaImg',
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    loading: {
      type: String,
      required: false,
      default: 'auto',
    },
  },
  setup(props) {
    // パスから拡張子を取得
    const getExtension = (src: string) => {
      const tmp = src.split('.');
      return tmp[tmp.length - 1];
    };

    // Retina
    const { src } = toRefs(props);
    const extension = getExtension(src.value);
    const src2x = ref(src.value.replace(`.${extension}`, `@2x.${extension}`));
    watch(src, () => {
      const extension = getExtension(src.value);
      src2x.value = src.value.replace(`.${extension}`, `@2x.${extension}`);
    });

    // decodingStatus
    const decodingStatus = ref<Decoding>('auto');
    if (props.loading === 'lazy') {
      decodingStatus.value = 'async';
    }

    return {
      src2x,
      decodingStatus,
    };
  },
});
